import React from "react";

/** Dark glass panel for customer pages inside SiteShell theme="dark". */
export default function DarkCard({ as: Tag = "div", className = "", children, ...rest }) {
  return (
    <Tag className={`home-glass-card rounded-[1.5rem] p-6 md:p-8 ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
